"use strict";
import ApiService from "@/core/services/api.service";

const baseURL = "MapProvider";

export default {
  getList() {
    return new Promise(resolve =>
      ApiService.get(`${baseURL}/GetList`).then(({ data }) => resolve(data))
    );
  },
  saveDefault(payload) {
    return new Promise(resolve => {
      ApiService.post(
        `${baseURL}/SaveDefault?mapProviderID=${payload}`
      ).result.then(({ data }) => {
        resolve(data);
      });
    });
  }
};
